// Core component styles
const coreStyles={container:{},icon:{}};/**
 * Combine component context styles with core styles
 * @param {Object} contextStyles
 * @return {Object}
 */const getStyles=contextStyles=>{return{container:{...coreStyles.container,...contextStyles.container},icon:{...coreStyles.icon,...contextStyles.icon}};};export default getStyles;